class ArtistasFilter {
  constructor() {
    this.sortSelect = document.getElementById('sort-order');
    this.sortOrder = '';

    this.init();
  }

  init() {
    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', (e) => this.handleSortChange(e));
    }

    // Carregar filtros da URL se existirem
    this.loadFiltersFromURL();
  }

  handleSortChange(e) {
    this.sortOrder = e.target.value;
    this.updateURL();
    this.dispatchFilterEvent();
  }

  dispatchFilterEvent() {
    const event = new CustomEvent('artistas-filter-change', {
      detail: {
        sortOrder: this.sortOrder
      }
    });
    document.dispatchEvent(event);
  }

  updateURL() {
    const params = new URLSearchParams(window.location.search);
    
    if (this.sortOrder) {
      params.set('sort', this.sortOrder);
    } else {
      params.delete('sort');
    }

    const newURL = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState({}, '', newURL);
  }

  loadFiltersFromURL() {
    const params = new URLSearchParams(window.location.search);
    
    // Carregar ordenação
    const sortParam = params.get('sort');
    if (sortParam && this.sortSelect) {
      this.sortSelect.value = sortParam;
      this.sortOrder = sortParam;
    }
  }
}

// Inicializar quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ArtistasFilter();
  });
} else {
  new ArtistasFilter();
}